import React from 'react'

const Header = () => {
  return (
    <header>
      <h1>Weather API React App</h1>
      <p className="github">By Ste Royle - <a href="https://github.com/steroyle/weather-api-react-app">View on GitHub</a></p>
    </header>
  )
}

export default Header